<p
  class="disclaimer"
  role="note"
  [attr.aria-label]="'app.components.parentAiAssistant.disclaimerAria' | translate"
>
  {{ 'app.components.parentAiAssistant.disclaimer' | translate }}
</p>
